import { RefObject, useEffect, useState } from 'react';

export const useScrollVisibility = (
  targetRef: RefObject<HTMLElement>,
): boolean => {
  const [isScrolledPast, setIsScrolledPast] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!targetRef.current) {
        return;
      }

      const rect = targetRef.current.getBoundingClientRect();

      const isPast = rect.bottom < 0;
      setIsScrolledPast(isPast);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [targetRef]);

  return isScrolledPast;
};
